import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_EVENT_FORM,
    CLEAR_EVENT_FORM_ERROR,
    CLEAR_EVENT_FORM_FIELD_ERROR,

    CHANGE_EVENT_FORM_FIELD,
    CHANGE_EVENT_FORM_FIELDS,

    VALIDATE_EVENT_FORM,

    SAVE_EVENT_REQUEST,
    SAVE_EVENT_SUCCESS,
    SAVE_EVENT_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_EVENT_FORM,
    CLEAR_ERROR: CLEAR_EVENT_FORM_ERROR,
    CLEAR_FIELD_ERROR: CLEAR_EVENT_FORM_FIELD_ERROR,
    CHANGE_FIELD: CHANGE_EVENT_FORM_FIELD,
    CHANGE_FIELDS: CHANGE_EVENT_FORM_FIELDS,
    VALIDATE: VALIDATE_EVENT_FORM,
    SUBMIT_REQUEST: SAVE_EVENT_REQUEST,
    SUBMIT_SUCCESS: SAVE_EVENT_SUCCESS,
    SUBMIT_FAILURE: SAVE_EVENT_FAILURE
}